import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import _values from 'lodash/values'
import { withTheme } from 'theming'

import { Link } from '..'

import useStyles, { variants } from './styles'


const Button = (props) => {
  const classes = useStyles(props)

  const { text, onClick, link, className, textClass, gatsbyLink, target } = props

  return (
    <Link
      route={gatsbyLink && gatsbyLink.route ? gatsbyLink.route : null}
      routeParams={gatsbyLink && gatsbyLink.routeParams ? gatsbyLink.routeParams : null}
      link={!gatsbyLink && link ? link : null}
      onClick={onClick}
      target={target}
      className={classNames('button', classes.container, className)}
    >
      <span className={classNames(classes.textContainer)}>
        <span className={classNames(classes.text, textClass)}>{text}</span>
      </span>
    </Link>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  classNames: PropTypes.any,
  textClass: PropTypes.string,
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
  gatsbyLink: PropTypes.shape({
    route: PropTypes.string,
    routeParams: PropTypes.any,
  }),
  target: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  variant: PropTypes.oneOf(_values(variants)),
  // eslint-disable-next-line react/no-unused-prop-types
  hasBorder: PropTypes.bool,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  className: null,
  textClass: '',
  classNames: {},
  link: null,
  gatsbyLink: null,
  target: undefined,
  onClick: () => undefined,
  hasBorder: true,
  variant: variants.Transparent,
}

export { variants } from './styles'

export default withTheme(Button)
